const testimonials = [
  {
    name: "Donna & Robert P.",
    location: "Gold Canyon, AZ",
    rating: 5,
    text: "We were heading back to Alberta for the summer and realized at the end of March that Robert's U.S. passport had expired back in 2020 — he never renewed it after COVID stopped all our travel. Called Fast Passport Center on a Thursday, shipped documents from the Mesa FedEx on Friday, and had his renewed passport in hand the following Thursday. We made our April departure date without any stress. This company saved our snowbird timeline.",
    service: "Passport Renewal",
  },
  {
    name: "Marcus T.",
    location: "Apache Junction, AZ",
    rating: 5,
    text: "I work for an East Valley semiconductor company and got a last-minute assignment to our Mexico City facility. Eight business days to departure and my passport had expired. Fast Passport Center handled my expedited renewal completely remotely — I shipped from the UPS store on Highway 60, they reviewed my documents, and I had my new passport six business days later. Incredible service when I needed it most.",
    service: "Emergency Renewal",
  },
  {
    name: "Linda F.",
    location: "Apache Junction, AZ",
    rating: 5,
    text: "My husband and I have been planning a bucket-list trip to Portugal for two years. When we finally booked flights, I discovered my passport was expiring three months after our return date — not enough validity for Schengen entry. Fast Passport Center handled my renewal in nine business days. The document checklist they sent was thorough and the review caught one issue before submission. Would not use anyone else.",
    service: "Standard Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function ApacheJunctionTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Apache Junction &amp; East Valley Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Gold Canyon, Apache Junction, and East Valley travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}